import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { fetchLoggedInHost } from './mixins/auth'
import { Store } from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLocationArrow, faUsers, faMoneyBillAlt } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare, faInstagram, faAngellist, faCcStripe } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import axios from 'axios'

library.add(...[faLocationArrow, faUsers, faMoneyBillAlt, faFacebookSquare, faInstagram, faAngellist, faCcStripe])
Vue.component('font-awesome-icon', FontAwesomeIcon)

axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/json'

// Object filter method used to query events
Object.filter = (obj, predicate) =>
  Object.keys(obj)
    .filter(key => predicate(obj[key]))
    .reduce((res, key) => {
      res[key] = obj[key]
      return res
    }, {})

Vue.config.productionTip = false

fetchLoggedInHost().then(host => {
  Store.setHost(host)
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
})
